import React from 'react';

const OpenInNewTabIcon = (props) => {
	return (
		<span class="open_in_new_tab knk-view gui_small_icon" />
	)
};

export default OpenInNewTabIcon;